import { FC } from 'react'
import { Divider } from '@cargomart/ui'
import { formatDateToMoscow } from 'src/helpers/dates'

export const OrderDeliveryDate: FC<{
  isCourier: boolean
  courierDate?: string
  terminalDate?: string
  terminalWorkTime?: string
}> = ({ terminalDate, courierDate, terminalWorkTime, isCourier }) => (
  <div className="flex flex-col gap-2 rounded-md bg-surface-variant p-4 text-body-md">
    <span className="text-title-sm">Расчётное время доставки</span>
    {terminalDate && (
      <div className="grid grid-cols-[minmax(200px,1fr)_2.5fr] gap-1">
        <span className="text-on-surface-variant">Прибытие на терминал</span>
        <span>{terminalDate}</span>
      </div>
    )}

    {isCourier && (
      <div className="grid grid-cols-[minmax(200px,1fr)_2.5fr] gap-1">
        <span className="text-on-surface-variant">Доставка курьером</span>
        <span>{courierDate ? formatDateToMoscow(courierDate || '') : '—'}</span>
      </div>
    )}

    {terminalWorkTime && (
      <div className="grid grid-cols-[minmax(200px,1fr)_2.5fr] gap-1">
        <span className="text-on-surface-variant">Рабочее время терминала</span>
        <span>{terminalWorkTime}</span>
      </div>
    )}

    {isCourier && !courierDate && (
      <>
        <Divider />
        <span>
          К сожалению, по указанному адресу отсутствуют данные о графике работы курьерской службы. Свяжитесь со Службой
          клиентской поддержки для уточнения сроков: 8 800 250-40-99
        </span>
      </>
    )}
  </div>
)
